// extracted by mini-css-extract-plugin
module.exports = {"dataRow":"DetailsListHeaderActionRow_dataRow__akvfG","dataRowContent":"DetailsListHeaderActionRow_dataRowContent__2l0j5"};